export default {
  "pdfFilmFeeBalance.monthDate": "年月",
  "pdfFilmFeeBalance.cinemasName": "劇場名",
  "pdfFilmFeeBalanceDetail.cinemasName": "対象劇場",
  "pdfFilmFeeBalance.exportAt": "作成",

  "pdfFilmFeeBalance.th.cinema": "劇場",
  "pdfFilmFeeBalance.th.client": "取引先",
  "pdfFilmFeeBalance.th.preMonthEndBalance": "前月末残高",
  "pdfFilmFeeBalance.th.currentMonthOccurs": "当月発生",
  "pdfFilmFeeBalance.th.currentMonthPay": "当月支払",
  "pdfFilmFeeBalance.th.currentMonthEndBalance": "当月末残高",
  "pdfFilmFeeBalance.th.cinemaTotal": "劇場計",
  "pdfFilmFeeBalance.th.total": "合計",

  "pdfFilmFeeBalance.title": "フィルム料残高一覧表",
  "pdfFilmFeeBalance.pdfTitle": "フィルム料残高一覧表 詳細版",
  "pdfFilmFeeBalance.cinemaName": "対象劇場（複数選択可）",
  "pdfFilmFeeBalance.month": "対象月",
  "pdfFilmFeeBalance.placeholder": "選択してください",
  "pdfFilmFeeBalance.allClients": "全取引先",
  "pdfFilmFeeBalance.targetYearMonth": "対象年月",
  "pdfFilmFeeBalance.clientTotal": "取引先計",
  "pdfFilmFeeBalance.cinemaTotal": "劇場計",
  "pdfFilmFeeBalance.sortingTypeText.client": "（取引先、劇場単位）",
  "pdfFilmFeeBalance.sortingTypeText.cinema": "（劇場、取引先単位）",
};